import { Route, Routes } from 'react-router-dom';
import Logs from '../components/logs/logs.component';
import DashboardPage from '../pages/merchant-pages/dashboard.page';
import MerchantBranchTransactionsPage from '../pages/merchant-pages/merchant-branch-transactions.page';
import PaymentLinksPage from '../pages/common-pages/payment-links.page';
import MissingPage from '../pages/common-pages/missing.page';
import UserManagement from '../components/user-management/user-management.component';

function MerchantBranchRoutes() {
  return (
    <Routes>
      <Route path="/" />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="create-payment-links" element={<PaymentLinksPage />} />
      <Route path="transactions" element={<MerchantBranchTransactionsPage />} />
      <Route path="logs" element={<Logs />} />
      <Route path="users">
        <Route index element={<UserManagement />} />
      </Route>
      <Route path="*" element={<MissingPage />} />
    </Routes>
  );
}

export default MerchantBranchRoutes;
